import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import CardActionArea from '@mui/material/CardActionArea';
import AddIcon from '@mui/icons-material/Add';
import ReactQuill from 'react-quill';


const NewPostEdit = ({ currentUser, dispatchPosts, modules, quillRef, type, socket }) => {

    const [show, setShow] = useState(false);

    const [editRaw, setEditRaw] = useState(false);

    const handleClose = () => {
        setEditRaw(false);
        setShow(false);
    };

    const [newPost, setNewPost] = useState({
        title: "",
        text: "",
        visible: true,
        order: 0,
        type: type
    });

    const handlePost = e => {
        e.preventDefault();
        let payload = { id: currentUser.user._id, jwt: currentUser.user.jwt, newPost, ip: localStorage.getItem('ip') };
        socket.emit('create post', payload);
        socket.on('new post', data => {
            dispatchPosts({ data, type: 'NEW_POST' });
        });
        handleClose();
    }

    const handleSetPost = e => {
        setNewPost({ ...newPost, text: e });
    }

    const handleVisible = () => {
        setNewPost({ ...newPost, visible: !newPost.visible });
    }

    return (
        <>
            <CardActionArea onClick={() => setShow(true)} sx={{ p: 3, textAlign: 'center' }}>
                <AddIcon sx={{ fontSize: 60 }} />
            </CardActionArea>
            <Dialog open={show} onClose={handleClose} fullScreen>
                <DialogTitle>New Article</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <TextField
                            label="Title"
                            required
                            fullWidth
                            value={newPost.title}
                            onChange={e => setNewPost({ ...newPost, title: e.target.value })}
                        />
                        <TextField
                            label="Order"
                            type="number"
                            required
                            fullWidth
                            value={newPost.order}
                            onChange={e => setNewPost({ ...newPost, order: e.target.value })}
                        />
                        <FormControlLabel
                            control={<Switch checked={newPost.visible} onChange={handleVisible} />}
                            label="Post Visible"
                        />
                        <FormControlLabel
                            control={<Switch checked={editRaw} onChange={() => setEditRaw(!editRaw)} />}
                            label="Raw HTML"
                        />
                        {editRaw ? (
                            <TextField
                                label="Raw HTML Editor"
                                multiline
                                fullWidth
                                minRows={20}
                                value={newPost.text}
                                onChange={e => setNewPost({ ...newPost, text: e.target.value })}
                            />
                        ) : (
                            <Box sx={{ bgcolor: '#585858', color: 'black' }}>
                                <ReactQuill
                                    theme="snow"
                                    ref={quillRef}
                                    value={newPost.text}
                                    modules={modules}
                                    formats={[
                                        'header', 'font', 'size', 'color',
                                        'bold', 'italic', 'underline', 'strike', 'blockquote',
                                        'list', 'bullet', 'indent',
                                        'link', 'image', 'video',
                                        'align', 'width', 'height', 'float',
                                    ]}
                                    onChange={(e) => {
                                        handleSetPost(e)
                                    }}
                                />
                            </Box>
                        )}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="warning" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="success" onClick={handlePost}>
                        Save Changes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default NewPostEdit
